import styled from "@emotion/styled";

import { MDSButton, MDSButtonSize, MDSButtonVariant, MDSFadeHorizontalScroll } from "@/mds";
import { TaskView } from "@/pages/agent/tasks/use-agent-tasks-search-params";

export const AgentTaskViewBar = ({
  selectedView,
  onChange,
}: {
  selectedView: TaskView;
  onChange: (view: TaskView) => void;
}) => (
  <StyledTaskViewBar aria-label="Task views">
    {TASK_VIEW_OPTIONS.map(option => (
      <MDSButton
        key={option.id}
        aria-pressed={selectedView === option.id}
        size={MDSButtonSize.Small}
        variant={
          selectedView === option.id ? MDSButtonVariant.Chrome : MDSButtonVariant.Transparent
        }
        onPress={() => onChange(option.id)}
      >
        {option.label}
      </MDSButton>
    ))}
  </StyledTaskViewBar>
);

const TASK_VIEW_OPTIONS = [
  { id: TaskView.TopOfMind, label: "Top of mind" },
  { id: TaskView.RecentlyAdded, label: "Recently added" },
  { id: TaskView.RecentlyUpdated, label: "Recently updated" },
  { id: TaskView.DueSoon, label: "Due soon" },
  { id: TaskView.RecentlyOverdue, label: "Recently overdue" },
  { id: TaskView.AllTasks, label: "All tasks" },
] as const;

const StyledTaskViewBar = styled(MDSFadeHorizontalScroll)`
  display: flex;
  gap: ${({ theme }) => theme.spacing[2]};

  > * {
    flex: 0 0 auto;
  }
`;
